<div class="modal-header">
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" style="display: block; max-height: 88%; margin-top: 1rem;">
  <app-privacy-policy></app-privacy-policy>
</div>
<div class="modal-footer justify-content-end" style="padding: 0px;padding-top: 10px;">
  <div class="col-12 col-md-4 text-right">
    <button type="button" class="btn btn-primary btn-dialog" (click)="onCloseClick()" cdkFocusInitial>{{ 'Close' | translate }}</button>
  </div>
</div>

